const getEquipmentsQRCodes = {
  toastr: 'Equipo agregado',
  toastr1: 'El equipo fue agregado con éxito.',
  toastrError: 'Equipo ya registrado',
  toastrError1: 'Ingrese este CNPJ o Nombre ya registrado'
};

export default getEquipmentsQRCodes;
